/// <reference path="../../../../../shared/models/generated/BankOperationsBankOperationReturnCheckApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/BankOperationsBankOperationReturnConvertApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/ZahlungsweisenVerifyHashModelApi.d.ts"/>

import { AppUtils } from '../../../../../shared/utils/index';
import { BasicApplicationUrlBuilder } from '../../../../../shared/services/BasicApplicationUrlBuilder';
import { GETbankoperationconvertApi } from '../../../../../shared/models/generated/GETbankoperationconvertApi';
import { GETbankoperationcheckApi } from '../../../../../shared/models/generated/GETbankoperationcheckApi';
import { AppCalculatorModel } from "../models/AppCalculatorModel";

export class AppApiService {

	private readonly options: BasicAppOptions<IbanAppDefinition>;
	private readonly applicationUrlBuilder: BasicApplicationUrlBuilder<IbanAppDefinition>;

	constructor(options: BasicAppOptions<IbanAppDefinition>) {
		this.options = options;
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder(options);
	}

	public calculateIban(bankdatenModel: AppCalculatorModel,
		successCallback: (data: BankOperationReturnConvertApi, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQuery.jqXHR) => void,
		errorCallback: (jqxhr: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		const params = new GETbankoperationconvertApi({
			Bankleitzahl: bankdatenModel.Bankleitzahl,
			Kontonummer: bankdatenModel.Kontonummer
		});
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apiiban),
			data: params.toRequestObject()
		}, (data: ApiResponse<BankOperationReturnConvertApi>) => {
			successCallback(data.Data);
		}, errorCallback
		);
	}

	public checkIban(bankdatenModel: AppCalculatorModel,
		successCallback: (data: BankOperationReturnCheckApi, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQuery.jqXHR) => void,
		errorCallback: (jqxhr: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		const params = new GETbankoperationcheckApi({
			Iban: bankdatenModel.Iban.replace(/ /g, "").toUpperCase(),
			Bic: bankdatenModel.Bic || ""
		});
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apiibancheck),
			data: params.toRequestObject()
		}, (data: BankOperationReturnCheckApi) => {
			successCallback(data);
		}, errorCallback);
	}

	public getCreditCardRequestData(successCallback: (data: VerifyHashModelApi, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQuery.jqXHR) => void,
		errorCallback: (jqxhr: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apicreditcard)
		}, (data: ApiResponse<VerifyHashModelApi>) => {
			successCallback(data.Data);
		}, errorCallback);
	}

}
